import rsms from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/RSMs/RSMs";
import rsm from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/RSMs/RSM";

import tdms from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/TDMs/TDMs";
import tdm from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/TDMs/TDM";

import kaes from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/KAEs/KAEs";
import kae from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/KAEs/KAE";

import agencies from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Agencies/Agencies";
import agency from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Agencies/Agency";

import networks from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Networks/Networks";
import network from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Networks/Network";

import externalformats from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/ExternalFormats/ExternalFormats";
import externalformat from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/ExternalFormats/ExternalFormat";

import outlettypes from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/OutletTypes/OutletTypes";
import outlettype from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/OutletTypes/OutletType";

import channels from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Channels/Channels";
import channel from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Channels/Channel";

import clusters from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Clusters/Clusters";
import cluster from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Clusters/Cluster";

import narkas from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/NARKAs/NARKAs";
import narka from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/NARKAs/NARKA";

import sipchannels from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/SIPChannels/SIPChannels";
import sipchannel from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/SIPChannels/SIPChannel";

import kass from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/KASs/KASs";
import kas from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/KASs/KAS";

import merchandisers from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Merchandisers/Merchandisers";
import merchandiser from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Merchandisers/Merchandiser";

import routecodes from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/RouteCodes/RouteCodes";
import routecode from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/RouteCodes/RouteCode";

import addressprogramorders from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/AddressProgramOrders/AddressProgramOrders";
import addressprogramorder from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/AddressProgramOrders/AddressProgramOrder";

import marsperiods from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/MarsPeriods/MarsPeriods";
import marsperiod from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/MarsPeriods/MarsPeriod";

import orders from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Orders/Orders";
import order from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Orders/Order";

import documents from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Documents/Documents";

import home from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Home/Home";

import adjustments from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Adjustments/Adjustments";
import adjustment from "../../../../Services/AddressProgramArchived/AddressProgramArchived.Frontend/views/Adjustments/Adjustment";

export const addressprogramarchivedRoutes = [
  {
    path: "/addressprogramarchived/rsms",
    name: "rsmsamarchived",
    component: rsms,
  },
  {
    path: "/addressprogramarchived/rsm/:id",
    name: "rsmamarchived",
    component: rsm,
    meta: {
      menuitem: "/addressprogramarchived/rsms",
    },
  },

  {
    path: "/addressprogramarchived/tdms",
    name: "tdmsamarchived",
    component: tdms,
  },
  {
    path: "/addressprogramarchived/tdm/:id",
    name: "tdmamarchived",
    component: tdm,
    meta: {
      menuitem: "/addressprogramarchived/tdms",
    },
  },

  {
    path: "/addressprogramarchived/kaes",
    name: "kaesamarchived",
    component: kaes,
  },
  {
    path: "/addressprogramarchived/kae/:id",
    name: "kaeamarchived",
    component: kae,
    meta: {
      menuitem: "/addressprogramarchived/kaes",
    },
  },

  {
    path: "/addressprogramarchived/agencies",
    name: "agenciesamarchived",
    component: agencies,
  },
  {
    path: "/addressprogramarchived/agency/:id",
    name: "agencyamarchived",
    component: agency,
    meta: {
      menuitem: "/addressprogramarchived/agencies",
    },
  },

  {
    path: "/addressprogramarchived/networks",
    name: "networksamarchived",
    component: networks,
  },
  {
    path: "/addressprogramarchived/network/:id",
    name: "networkamarchived",
    component: network,
    meta: {
      menuitem: "/addressprogramarchived/networks",
    },
  },

  {
    path: "/addressprogramarchived/externalformats",
    name: "externalformatsamarchived",
    component: externalformats,
  },
  {
    path: "/addressprogramarchived/externalformat/:id",
    name: "externalformatamarchived",
    component: externalformat,
    meta: {
      menuitem: "/addressprogramarchived/externalformats",
    },
  },

  {
    path: "/addressprogramarchived/outlettypes",
    name: "outlettypesamarchived",
    component: outlettypes,
  },
  {
    path: "/addressprogramarchived/outlettype/:id",
    name: "outlettypeamarchived",
    component: outlettype,
    meta: {
      menuitem: "/addressprogramarchived/outlettypes",
    },
  },

  {
    path: "/addressprogramarchived/channels",
    name: "channelsamarchived",
    component: channels,
  },
  {
    path: "/addressprogramarchived/channel/:id",
    name: "channelamarchived",
    component: channel,
    meta: {
      menuitem: "/addressprogramarchived/channels",
    },
  },

  {
    path: "/addressprogramarchived/clusters",
    name: "clustersamarchived",
    component: clusters,
  },
  {
    path: "/addressprogramarchived/cluster/:id",
    name: "clusteramarchived",
    component: cluster,
    meta: {
      menuitem: "/addressprogramarchived/clusters",
    },
  },

  {
    path: "/addressprogramarchived/narkas",
    name: "narkasamarchived",
    component: narkas,
  },
  {
    path: "/addressprogramarchived/narka/:id",
    name: "narkaamarchived",
    component: narka,
    meta: {
      menuitem: "/addressprogramarchived/narkas",
    },
  },

  {
    path: "/addressprogramarchived/sipchannels",
    name: "sipchannelsamarchived",
    component: sipchannels,
  },
  {
    path: "/addressprogramarchived/sipchannel/:id",
    name: "sipchannelamarchived",
    component: sipchannel,
    meta: {
      menuitem: "/addressprogramarchived/sipchannels",
    },
  },

  {
    path: "/addressprogramarchived/kass",
    name: "kassamarchived",
    component: kass,
  },
  {
    path: "/addressprogramarchived/kas/:id",
    name: "kasamarchived",
    component: kas,
    meta: {
      menuitem: "/addressprogramarchived/kass",
    },
  },

  {
    path: "/addressprogramarchived/merchandisers",
    name: "merchandisersamarchived",
    component: merchandisers,
  },
  {
    path: "/addressprogramarchived/merchandiser/:id",
    name: "merchandiseramarchived",
    component: merchandiser,
    meta: {
      menuitem: "/addressprogramarchived/merchandisers",
    },
  },

  {
    path: "/addressprogramarchived/routecodes",
    name: "routecodesamarchived",
    component: routecodes,
  },
  {
    path: "/addressprogramarchived/routecode/:id",
    name: "routecodeamarchived",
    component: routecode,
    meta: {
      menuitem: "/addressprogramarchived/routecodes",
    },
  },

  {
    path: "/addressprogramarchived/dashboard",
    name: "dashboardamarchived",
    component: home,
  },
  {
    path: "/addressprogramarchived/addressprogramorders",
    name: "addressprogramordersamarchived",
    component: addressprogramorders,
  },
  {
    path: "/addressprogramarchived/addressprogramorder/:id",
    name: "addressprogramorderamarchived",
    component: addressprogramorder,
    meta: {
      menuitem: "/addressprogramarchived/addressprogramorders",
    },
  },
  {
    path: "/addressprogramarchived/addressprogramorder/adjustmentmultiplecreate",
    name: "adjustmentmultiplecreateamarchived",
    component: addressprogramorder,
    meta: {
      menuitem: "/addressprogramarchived/addressprogramorders",
    },
  },

  {
    path: "/addressprogramarchived/marsperiods",
    name: "marsperiodsamarchived",
    component: marsperiods,
  },
  {
    path: "/addressprogramarchived/marsperiod/:id",
    name: "marsperiodamarchived",
    component: marsperiod,
    meta: {
      menuitem: "/addressprogramarchived/marsperiods",
    },
  },

  {
    path: "/addressprogramarchived/orders",
    name: "ordersamarchived",
    component: orders,
  },
  {
    path: "/addressprogramarchived/order/:id",
    name: "orderamarchived",
    component: order,
    meta: {
      menuitem: "/addressprogramarchived/orders",
    },
  },

  {
    path: "/addressprogramarchived/documents",
    name: "documentsamarchived",
    component: documents,
  },
  {
    path: "/addressprogramarchived/document/:id",
    name: "documentamarchived",
    component: document,
    meta: {
      menuitem: "/addressprogramarchived/documents",
    },
  },

  {
    path: "/addressprogramarchived/adjustments",
    name: "adjustmentsamarchived",
    component: adjustments,
  },

  {
    path: "/addressprogramarchived/adjustment/:id",
    name: "adjustmentamarchived",
    component: adjustment,
    meta: {
      menuitem: "/addressprogramarchived/adjustments",
    },
  },
];

export default addressprogramarchivedRoutes;
